import { Injectable } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { AppIcons } from 'app/account/shared';

@Injectable({
	providedIn: 'root'
})

export class AppMenuService {
	constructor(private sanitizer: DomSanitizer) { }

	getAppMenus() {
		return [
			{
				'svg': this.sanitizer.bypassSecurityTrustHtml(AppIcons.dashboard),
				'title': 'Dashboard',
				'url': '/dashboard'
			},

			{
				'svg': this.sanitizer.bypassSecurityTrustHtml(AppIcons.master),
				'title': 'Master',
				'caret': 'true',
				'systemNameList': [
				],
				'submenu': [
					{
						'url': '/store-master',
						'title': 'Store',
						'childSystemNameList': ["Store.Read"]
					},
					{
						'url': '/billserialno',
						'title': 'Bill Serial No',
						'childSystemNameList': ["BillSetting.Read"]
					},
					//Future Use
					// {
					// 	'url': '/store-ops-role',
					// 	'title': 'Store Operation  Role',
					// 	'childSystemNameList': [""]
					// },
					{
						'url': '/diamond-making-Charges-list',
						'title': 'Diamond Making Charges',
					},
					{
						'url': '/gold-making-charges',
						'title': 'Gold Making Charges',
					},
					{
						'url': '/customer-master',
						'title': 'Customer Master',
						'childSystemNameList': [
						]
					},
					// {
					// 	'url': '/payment-type',
					// 	'title': 'Payment Type',
					// },
					{
						'url': '/repair-work',
						'title': 'Repair Work',
						'childSystemNameList': ["RepairWork.Read"]
					},
					{
						'url': '/gold-rate',
						'title': 'Kisna Old Gold Purchase Rate',
						'childSystemNameList': ["OldGoldPurchaseRate.Read"]
					},

					{
						'url': '/walk-in-source',
						'title': 'Walk In Source'
					},
					{
						'url': '/return-deduction',
						'title': 'Return Deduction',
						'childSystemNameList': ["ReturnDeduction.Read"]
					},
					{
						'url': '/gold-rate-master',
						'title': 'Gold-Rate',
					},
					{
						'url': '/expense-master',
						'title': 'Expense Master'
					},
					{
						'url': '/gold-rate-protection-master',
						'title': 'Gold Rate Protection'
					},
					{
						'url': '/ist-margin',
						'title': 'IST Margin',
					},
					{
						'url': '/exchange-margin',
						'title': 'Exchange Margin',
					},
					{
						'url': '/e-gold-redemption',
						'title': 'E-Gold Redemption',
					},
					{
						'url': '/reject-return-reason',
						'title': 'Rejection/Return Order Reason',
					},
					{
						'url': '/making-charge',
						'title': 'Making Charge Assignment',
					},
					{
						'url': 'making-charge/gd-making-charge',
						'title': 'Gd Making Charge',
					},

				]
			},
			{
				'icon': 'fa fa-percent',
				'title': 'Discount',
				'caret': 'true',
				'submenu': [
					// {
					// 	'url': '/discount-voucher',
					// 	'title': 'Discount Voucher',
					// },
					{
						'url': '/promo-discount',
						'title': 'Promo Discount',
					},
					{
						'url': '/promo-master',
						'title': 'Promo Master',
					},
					{
						'url': '/promo-coupon-master',
						'title': 'Promo Coupon Master',
					},
				]
			},
			// {
			// 	'svg': this.sanitizer.bypassSecurityTrustHtml(AppIcons.store),
			// 	'title': 'Store',
			// 	'caret': 'true',
			// 	'systemNameList': [
			// 		"Store.Read", "BillType.Read"
			// 	],
			// 	'submenu': [

			// 		// {
			// 		// 	'url': '/billType',
			// 		// 	'title': 'Bill Type',
			// 		// 	'childSystemNameList': ["BillType.Read"]
			// 		// },

			// 		// {
			// 		// 	'url': '/sales-person',
			// 		// 	'title': 'Sales Person',
			// 		// }
			// 	]
			// },

			{
				'svg': this.sanitizer.bypassSecurityTrustHtml(AppIcons.productInventory),
				'title': 'Product Inventory',
				'caret': 'true',
				'submenu': [
					{
						'url': '/product-inventory',
						'title': 'Product',
					},
					// {
					// 	'url': '/product-inventory',
					// 	'title': 'Regular Inventory',
					// },
					// {
					// 	'url': '/snmcc-inventory',
					// 	'title': 'SNMCC Inventory',
					// },
					{
						'url': '/snmcc-inventory/snmcc-admin',
						'title': 'SNMCC Admin',
					},
					{
						'url': 'consignment-admin',
						'title': 'Consignment Admin',
					},
				]
			},
			{
				'icon': 'fas fa-folder-open',
				'title': 'Directory',
				'caret': 'true',
				'submenu': [

					{
						'url': '/country-master',
						'title': 'Country Master',
					},
					{
						'url': '/state-master',
						'title': 'State Master',
					},
					{
						'url': '/city-master',
						'title': 'City Master',
					}

				]
			},
			// {
			// 	'icon': 'fa fa-money-bill',
			// 	'title': 'Making Charges',
			// 	'caret': 'true',
			// 	'submenu': [

			// 	]
			// },
			{
				'svg': this.sanitizer.bypassSecurityTrustHtml(AppIcons.user),
				'title': 'User Managment',
				'caret': 'true',
				'systemNameList': [

				],
				'submenu': [
					{
						'url': '/user',
						'title': 'Users',
						"childSystemNameList": [
						]
					},
					{
						'url': '/roles',
						'requiresStoreSelection': true,
						'title': 'User Role',
					}
				]
			},
			{
				'svg': this.sanitizer.bypassSecurityTrustHtml(AppIcons.transaction),
				'title': 'Transaction',
				'caret': 'true',
				'systemNameList': [

				],
				'submenu': [
					{
						'url': '/transaction/sales-Order-list',
						'title': 'Sales Order List',
						"childSystemNameList": [
						]
					},
					{
						'url': '/transaction/return-sales-order-list',
						'title': 'Return Sales Order List',
						"childSystemNameList": [
						]
					},
					{
						'url': '/transaction/customer-ledger-list',
						'title': 'Customer Ledger List',
						"childSystemNameList": [
						]
					}
				]
			},
			{
				'svg': this.sanitizer.bypassSecurityTrustHtml(AppIcons.transaction),
				'title': 'Enquiry',
				'caret': 'true',
				'systemNameList': [

				],
				'submenu': [
					{
						'url': '/enquiry',
						'title': 'Enquiry List',
						"childSystemNameList": [
						]
					},
				]
			},
			{
				'icon': 'fa fa-trophy',
				'title': 'Incentive',
				'caret': 'true',
				'submenu': [
					{
						'url': '/incentive/dashboard',
						'title': 'Dashboard',
					},
					{
						'url': '/incentive/groups',
						'title': 'Incentive Group Master',
					},
					{
						'url': '/incentive/targets',
						'title': 'Target Master',
					},
					{
						'url': '/incentive/rules',
						'title': 'Rule Master',
					},
					{
						'url': '/incentive/kmr',
						'title': 'KMR Integration',
					},
					{
						'url': '/incentive/approvals',
						'title': 'Approval Queue',
					},
					{
						'url': '/incentive/audit',
						'title': 'Version & Audit',
					},
					{
						'url': '/incentive/simulation',
						'title': 'Rule Simulation',
					},
				]
			},

		]
	}

}
